import React, { useState } from "react";
import { CheckCircle, SettingsRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

import { NavigationButton } from "ui";

import { Maybe, VersionScenarioConfiguration } from "fond/types";

import SetupForm from "./SetupModal";

interface SetupPanelProps {
  configuration: Maybe<VersionScenarioConfiguration>;
  isDisabled: boolean;
}

const SetupPanel: React.FC<SetupPanelProps> = ({ configuration, isDisabled }) => {
  const [open, setOpen] = useState(false);

  const handleOnClick = () => {
    setOpen(true);
  };

  return (
    <>
      <Typography>Setup the configuration for cost to serve.</Typography>
      <NavigationButton
        title="Setup"
        icon={<SettingsRounded />}
        onClick={handleOnClick}
        disabled={isDisabled}
        rightElement={
          configuration && (
            <Box display="flex" alignItems="center">
              <CheckCircle color="success" sx={{ fontSize: 18 }} />
            </Box>
          )
        }
      />

      {open && <SetupForm onClose={() => setOpen(false)} configuration={configuration} />}
    </>
  );
};

export default SetupPanel;
